<script>
/**
 * ****************************************************************************
 * @description     :   Input DatePicker Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import moment from 'moment';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input datepicker component
 */
var AnsDatePicker = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        inputStyle: Object,
        buttonClass: String,
        placeholder: String,
        value: String,
        modelValue: String,
        is24h: {
            type: Boolean,
            default: true
        },
        maxHour: {
            type: Number,
            default: 24
        },
        isRequired: Boolean,
        showButton: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChangeEvent: Function,
        onKeyUpEvent: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: _.uuid(),
            id1: _.uuid(),
            id2: _.uuid(),
            showPicker: false,
            HH: '00',
            mm: '00',
            count: 0
        };
    },
    computed: {
        vewValue: {
            get() {
                return this.convertTimeString(
                    this.modelValue ? this.modelValue : this.value
                );
            },
            set() {}
        }
    },
    watch: {
        modelValue() {
            this.setDataPicker();
        },
        value() {
            this.setDataPicker();
        }
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        }
        this.setDataPicker();
    },
    methods: {
        /**
         * event keydown on input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 13 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 186
                )
            ) {
                e.preventDefault();
                return false;
            }
            return true;
        },
        inputKeyup(e) {
            if (this.onKeyUpEvent) {
                this.onKeyUpEvent(e);
            }
        },
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params : value
         * @access : private
         */
        convertTimeString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            if (this.is24h && this.maxHour <= 24) {
                var reg1 = /^([01][0-9]|2[0-3])([0-5][0-9])$/;
                var reg2 = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
                var reg3 = /^([0-9])([0-5][0-9])$/;
                var reg4 = /^([0-5][0-9])$/;
                var reg5 = /^([0-9]):([0-5][0-9])$/;
                if (value.match(reg1)) {
                    value = value.substring(0, 2) + ':' + value.substring(2, 4);
                }
                if (value.match(reg3)) {
                    value = value.substring(0, 1) + ':' + value.substring(1, 3);
                }
                if (value.match(reg4)) {
                    value = '0:' + value;
                }
                if (!value.match(reg2) && !value.match(reg5)) {
                    value = '';
                }
            } else {
                value = (value + '').replace(/\D/g, '');
                if (value.length == 0) {
                    return '0:00';
                }
                if (value.length == 1) {
                    return '0:0' + value;
                }
                if (value.length == 2) {
                    return '0:' + value;
                }
                const hour = parseInt(value.substr(0, value.length - 2));
                if (hour >= this.maxHour) {
                    return '';
                }
                const minute = parseInt(
                    value.substr(value.length - 2, value.length)
                );
                if (minute >= 60) {
                    return '';
                }
                return (
                    value.substr(0, value.length - 2) +
                    ':' +
                    value.substr(value.length - 2, value.length)
                );
            }
            return value;
        },
        setDataPicker() {
            let val = this.vewValue;
            if (val == '') {
                val = moment().format('HH:mm');
            }
            const vals = val.split(':');
            this.HH = vals[0];
            this.mm = vals[1];
        },
        setTime(mm) {
            this.changeModel(`${this.HH}:${mm}`);
            this.showPicker = false;
            setTimeout(() => {
                document.getElementById(`${this.newId}`).focus();
            }, 0);
        },
        updateValue(e) {
            this.changeModel(this.convertTimeString(e.target.value));
            this.count++;
            setTimeout(() => {
                document.getElementById(`${this.newId}`).focus();
            }, 0);
        },
        changeModel(val) {
            if ((this.vewValue ?? '') != (val ?? '')) {
                this.$emit('update:modelValue', val);
                // eslint-disable-next-line no-undef
                $(`#${this.newId}`).RemoveError();
                if (this.onChangeEvent) {
                    this.onChangeEvent(val);
                }
                if (this.onChange) {
                    this.onChange(val);
                }
            }
        },
        showTwoCharacter(val) {
            return `${val < 10 ? '0' : ''}${val}`;
        },
        selectedHH(val) {
            val = this.showTwoCharacter(val);
            if (this.HH == '0') {
                this.HH = '00';
            }
            return (
                val == this.HH
                // ||(this.HH == '00' && val == moment().format('HH'))
            );
        },
        selectedMM(val) {
            val = this.showTwoCharacter(val);
            return (
                val == this.mm
                // ||(this.mm == '00' && val == moment().format('mm'))
            );
        },
        clickShowPicker() {
            this.showPicker = !this.showPicker;
            this.setDataPicker();
            if (this.showPicker) {
                setTimeout(() => {
                    const myElement = document.getElementById(
                        `${this.id1}hh${this.HH}`
                    );
                    if (myElement) {
                        const topPos = myElement?.offsetTop;
                        document.getElementById(`${this.id1}`).scrollTop =
                            topPos - 10;
                    }
                    const myElement2 = document.getElementById(
                        `${this.id2}mm${this.mm}`
                    );
                    if (myElement2) {
                        const topPos2 = myElement2.offsetTop;
                        document.getElementById(`${this.id2}`).scrollTop =
                            topPos2 - 10;
                    }
                }, 10);
            }
        }
    }
};
export default AnsDatePicker;
</script>
